<template>
  <ConfirmationModal
    :entity="currentBuyer"
    :title="$t('RESET_COUNTERS_MODAL_HEADER', { target: 'Buyer' })"
    :cancel-button-text="$t('CANCEL')"
    :confirm-action-text="$t('RESET_COUNTERS_MODAL_YES')"
    :confirm-button-loading="isBuyerResetCapCountersLoading"
    @confirm="$emit('confirm', currentBuyer)"
    @close="$emit('close', currentBuyer)"
  >
    <span
      v-html="
        $t('RESET_COUNTERS_MODAL_BODY', {
          target: 'Buyer',
        })
      "
    >
      <br />
    </span>
  </ConfirmationModal>
</template>

<script>
import ConfirmationModal from '@/core/components/ConfirmationModal/ConfirmationModal.vue';
import sharedMessages from '@/core/locales';
import messages from '../locales';

export default {
  name: 'BuyerResetCapCountersModal',
  components: {
    ConfirmationModal,
  },
  props: {
    currentBuyer: {
      type: Object,
      default: () => ({}),
    },
    isBuyerResetCapCountersLoading: {
      type: Boolean,
      default: false,
    },
  },
  i18n: {
    messages,
    sharedMessages,
    locale: 'en',
  },
};
</script>

<style>
</style>